export default __webpack_public_path__ + "static/media/cloud-1.5f830f8b.webp";